module.exports = __webpack_public_path__ + "static/img/zt1-pic7.86e910f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt1-pic7.jpg
// module id = qBy+
// module chunks = 171